import { User } from '../objects/user';
import { Version } from '../objects/version';
import { Approval } from '../objects/approval';

// reset to before share upload version feature
export interface VersionFeedback {
    user: User;
    version: Version;
    approval: Approval | null;
    status?: VersionFeedbackStatus | null;  
    // optional status!!  if not, check approval & set status open.
}
// status added in 10/08/2023 to include completed status when no approval
export interface VersionFeedbackStatus {
    date: string;
    status_code: number;  // 0: archivado // 1: abierto // 2: completado
    status_text?: string;
}

export interface ShareVersionFeedback extends VersionFeedback {
  share: any;
    // TODO: share should be like
    // {date_created: string
    // entry:  
    // message: string
    // options:    {allow_see: true, get_approval: true, get_comments: true, get_signature: true}
    // owner: user}

}

/**
 * Enumeration of possible `CODES` for version feedbacks "general" status
 *
 * @enum { number } 
 */
export enum FeedbackStatusCodeEnum {
  ARCHIVED_CODE = 0, // Archived
  OPENED_CODE = 1, // Opened
  CLOSED_CODE = 2, // Completed,
  WRONG_CODE = 10
}

export enum FeedbackStatusTextEnum {
  ARCHIVED_TEXT = 'Archived',
  OPENED_TEXT = 'Reset',
  CLOSED_TEXT = 'Completed',
}

/**
 * Enumeration of possible `CODES` for version feedback approvals status
 *
 * @enum { number } 
 */
export enum ApprovalStatusCodeEnum {
  PENDING_CODE = 0,
  APPROVED_CODE = 1,
  REJECTED_CODE = 2
}


/**
 * Array of `COLORS` for version feedback approvals status according status
 * source ['#F6B273','#47B934','#F44848'];
 *  
 */
export const ApprovalStatusColorValues: { [key: number]: string } = {
  [ApprovalStatusCodeEnum.PENDING_CODE]: '#F6B273',    // Orange for Pending
  [ApprovalStatusCodeEnum.APPROVED_CODE]: '#47B934',   // Green for Approved
  [ApprovalStatusCodeEnum.REJECTED_CODE]: '#F44848',  // Red for Rejected
};

/**
 * Array of `COLORS` for version feedback approvals status according status
 * source ['#F6B273','#47B934','#F44848'];
 *  
 */
export const FeedbackStatusColorValues: { [key: number]: string } = {
  [FeedbackStatusCodeEnum.ARCHIVED_CODE]: 'black',    // TBD for ARCHIVED
  [FeedbackStatusCodeEnum.OPENED_CODE]: 'silver',   // silver grey for opened
  [FeedbackStatusCodeEnum.CLOSED_CODE]: '#2E49EB',  // blue twona for Closed/coimpleted
  [FeedbackStatusCodeEnum.WRONG_CODE]: '#FCFF82',  // yellow  for wrong
};

